
<div  class="container">
  <div class="row">
    <div class="col-lg-12">
      <div id="demo-img-container" class="demo-img-container">
        <div class="demo-img-wrapper">
          <img #sourceImage id="selectedImage" (click)="onPointSelect($event)"/>
          <div *ngIf="this.sourceImage == null">
            No Image Configured
          </div>
          <div *ngIf="sourceImage">
            
            <div *ngFor="let object of overlayConfig; let i = index">

              <ng-template #tooltipTmpl>
                <div class="tooltipStyle">
                  <div>Name: {{object.name}}</div>
                  <div>Value: {{object.value}}</div>
                  <div>Time: {{getElapsedTime(object)}}</div>
                </div>
              </ng-template>  

              <div [ngSwitch]="object.displayOption" (click)="selectObject(object)">
                <div *ngSwitchCase="'text'">
                  <div id="rect-{{object.uri}}" class="object-rectangle" [ngClass]="getStyle(object)" style="left:{{ object.startX }}%; top:{{ object.startY }}%;">
                    <!--[tooltip]="tooltipTmpl"  placement="right">-->
                    <span *ngIf="object.showName" class="text">{{ object.name }} : </span>
                    <span class="text">{{ object.value }}</span>
                  </div>
                </div>
                <div *ngSwitchCase="'light-stack'"> 
                  <span id="stack-container-{{object.uri}}" class="light-stack-container" style="left:{{ object.startX}}%; top:{{ object.startY}}%;">
                    <div *ngFor="let obj of overlayLightMap.get(i) | lightStackFilter ">
                      <div class="light-stack light-stack-{{obj.type}}"
                            [tooltip]="tooltipTmpl">
                      </div>
                      
                    </div>
                  </span>
                </div>
                <div *ngSwitchCase="'dot'"> 
                    <span id="stack-container-{{object.uri}}" class="dot light-stack-container" style="left:{{ object.startX}}%; top:{{ object.startY}}%;">
                      <div class="light-stack light-stack-transparent"
                            isFirstTime=true
                            [tooltip]="tooltipTmpl"
                            placement="auto" >
                      </div>
                      <span [ngClass]="{'text':object.x <= 95, 'text-left': object.x > 95}" class="text" *ngIf="object.showName" [ngStyle]="{'color':object.colour}">{{ object.name }}</span>
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>